import React from 'react';
import SearchBox from '../../../components/outline/SearchBox';
import BaseForm from '../../../components/form/BaseForm';
import CheckBox from '../../../components/input/CheckBox';
import { CouponListSearchOption } from '../../../types/coupons/list-v2';

type CouponListSearchBoxProps = {
  searchData: CouponListSearchOption;
  onSearch: (searchOption: CouponListSearchOption) => void;
  onClear: () => void;
  onSearchDataChange: (data: Partial<CouponListSearchOption>) => void;
};

export const CouponListSearchBox = (props: CouponListSearchBoxProps) => {
  const { searchData, onSearch, onClear, onSearchDataChange } = props;

  return (
    <SearchBox
      className="coupon-list-search-box"
      onSearch={() => {
        onSearch({
          couponAvailability: searchData.couponAvailability,
        });
      }}
      onClear={onClear}
    >
      <BaseForm
        label="발급 가능 여부"
        content={
          <CheckBox
            checked={searchData.couponAvailability}
            onChange={(checked: boolean) =>
              onSearchDataChange({ couponAvailability: checked })
            }
          />
        }
      />
    </SearchBox>
  );
};
